import { CancelToken } from "axios";
import { instance as axios } from "@services/axios";
import { catchUndefinedProp } from "@utils/catchUndefinedProps";

export interface IProfileDto {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  phone: string;
  profileImageHash: string;
  profileImageId: string;
  username: string;
}

export const PROFILE = window._env_.SERVER_IDENTITY + "/User/Profile";

export const getProfile = (cancelToken?: CancelToken) =>
  new Promise<IProfileDto>((resolve, reject) => {
    axios
      .get(PROFILE, {
        cancelToken,
      })
      .then((res: any) => {
        try {
          const result = mapProfile(res.data);
          resolve(result);
        } catch (err) {
          reject(err);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });

const mapProfile = (data: any): IProfileDto => {
  const result: IProfileDto = {
    email: data.email,
    firstName: data.firstName,
    id: data.id,
    lastName: data.lastName,
    phone: data.phone,
    profileImageHash: data.profileImageHash,
    profileImageId: data.profileImageId,
    username: data.username,
  };
  catchUndefinedProp(result);
  return result;
};
